
// Kompakt rad på mobil, kort med ikon ovanför från sm
const ServiceCard = ({ index, icon: Icon, title, description }) => {
    return (
        <div className="card group flex items-start gap-4 p-4 transition-colors duration-300 hover:border-sky-500/60 sm:flex-col sm:p-6">
            <div className="flex shrink-0 items-center justify-between sm:w-full">
                <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-sky-500/10 text-sky-500 transition-colors duration-300 group-hover:bg-sky-500 group-hover:text-slate-950 sm:h-11 sm:w-11">
                    <Icon size={18} />
                </span>
                <span className="hidden font-mono text-xs text-slate-400 dark:text-slate-500 sm:inline">
                    {String(index + 1).padStart(2, "0")}
                </span>
            </div>
            <div className="flex flex-col gap-1 sm:gap-4">
                <h3 className="font-semibold text-slate-900 dark:text-white sm:text-lg">{title}</h3>
                <p className="text-sm leading-relaxed text-slate-600 dark:text-slate-400">{description}</p>
            </div>
        </div>
    )
}


export default ServiceCard;
